import { Component, OnInit, Input, Output, EventEmitter, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { fciWebsiteService } from '../../service/fci-website.service';
import { HttpEvent, HttpEventType } from '@angular/common/http';
// import { ConsoleReporter } from 'jasmine';
import { environment } from 'src/environments/environment';
declare let $: any;

@Component({
  selector: 'app-seeyourdepot',
  templateUrl: './seeyourdepot.component.html',
  styleUrls: ['./seeyourdepot.component.css']
})
export class SeeyourdepotComponent implements OnInit, AfterViewInit {


  ngAfterViewInit(): void {
    //FOR SCROLLING TO TOP WHEN COMPONENT LOADS
    // $('html, body').scrollTop(0);
  }

  constructor(private fciwebservice: fciWebsiteService, private routerparam: ActivatedRoute) { }
  query_menu: any;
  param_menualias: any;
  mainmenuid: any;
  content_page_parames: any;
  sortmenu: any;
  ngOnInit(): void {
    this.query_menu = this.routerparam.snapshot.queryParamMap.get('menu');
    this.param_menualias = this.routerparam.snapshot.paramMap.get('menualias');
    this.mainmenuid = this.routerparam.snapshot.paramMap.get('mainmenuid');

    this.content_page_parames = {
      'query_menu': this.query_menu, 'param_menualias': this.param_menualias, 'mainmenuid': this.mainmenuid, menutype: 'primary', 'innermenualias': '', 'innermenuaid': ''
    }
    if (this.routerparam.snapshot.queryParamMap.get('menu')) {
      this.sortmenu = this.query_menu.split('+');
    } else {
      this.sortmenu = ['', ''];
    }
  }

}
